
import { API_URLS } from "../url";
import axiosInstance from "../axiosInstance";
import { showToast } from "../../utils/toast";
import { LoginFormPayload, SampleAuthApiResponse } from "types/auth";
import { AuthApiResponse } from "types/auth";
import { SignupPayload } from "types/signup";

export const googleLoginApi = async (code: string) => {
  try {
    const { data } = await axiosInstance.post(API_URLS.GOOGLE_LOGIN, { code });
    return data;
  } catch (error: any) {
    if (
      !error.response ||
      error.code === "ECONNABORTED" ||
      error.message?.includes("timeout")
    ) {
      
      showToast.error("Network error. Please try again.");
    }
    throw error;
  }
};

export const userLoginApi = async (
  payload: LoginFormPayload
): Promise<AuthApiResponse> => {
  try {
    const  {data}  = await axiosInstance.post<SampleAuthApiResponse>(
      API_URLS.USER_LOGIN,
      payload 
    );
    return data.response; 
  } catch (error: unknown) {
    showToast.error("Error");
    throw error; 
  }
};

export const userSignupApi = async (payload: SignupPayload) => {
  try {
    const { data } = await axiosInstance.post(API_URLS.USER_SIGNUP, payload);
    return data;
  } catch (error: any) {
    if (
      !error.response ||
      error.code === "ECONNABORTED" ||
      error.message?.includes("timeout")
    ) {
      showToast.error("Network error. Please try again.");
    }
    throw error;
  }
}

export const verifyOtpApi = async (payload: { email: string; otp: string }) => {
  const { data } = await axiosInstance.post(API_URLS.VERIFY_OTP, payload);
  return data.response;
};

export const resendOtpApi = async (payload: { email: string }) => {
  const { data } = await axiosInstance.post(API_URLS.RESEND_OTP, payload);
  return data.response;
};

export const forgotPasswordApi = async (email: string) => {
  const { data } = await axiosInstance.post(API_URLS.FORGOT_PASSWORD, { email });
  return data.response;
};

export const resetPasswordApi = async (resetKey: string, password: string) => {
  const { data } = await axiosInstance.post(`${API_URLS.RESET_PASSWORD}/${resetKey}`, { password });
  return data.response;
};